import { AutogenModelLoginSettings, AutogenRowLoginSettings } from "./autogen/AutogenModelLoginSettings";

export class ModelLoginSettings extends AutogenModelLoginSettings<RowLoginSettings> {
	constructor() {
		super(RowLoginSettings);
	}
}

export class RowLoginSettings extends AutogenRowLoginSettings {
}